export function faviconUrl(url: string): string {
  const host = new URL(url).hostname
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=128`
}
